import { Title } from '@mantine/core';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import AccreditationBanner from 'components/shared/AccreditationBanner';
import HeaderPortal from 'components/shared/HeaderPortal';
import { MENU_ITEMS } from 'layouts/LkLayout/SideMenu/Menu/config';
import { useAppConfig } from 'stores/global/RootStore/context';
import { useDevices } from 'utils/devices';

import { isPathMatch, NON_MENU_TITLES } from './config';

import s from './AccreditationPage.module.scss';

const AccreditationPage: React.FC = () => {
  const { isPhone, isTablet } = useDevices();
  const { logic } = useAppConfig();
  const location = useLocation();

  const lkTitle = React.useMemo(() => {
    const menuItem = MENU_ITEMS.find(({ to, activePaths }) => {
      const paths = activePaths ?? [to];

      return paths.some((path) => isPathMatch(location.pathname, path));
    });

    if (!menuItem) {
      return NON_MENU_TITLES.find(({ path }) => isPathMatch(location.pathname, path))?.title ?? '';
    }

    return menuItem.sectionTitleKey && logic.sectionTitles[menuItem.sectionTitleKey]
      ? logic.sectionTitles[menuItem.sectionTitleKey]
      : menuItem.label;
  }, [location.pathname, logic.sectionTitles]);

  return (
    <div className={s.root}>
      {isPhone ? (
        <Title size="h3" fw={500} className={s.root__title}>
          {lkTitle}
        </Title>
      ) : (
        <HeaderPortal>
          <Title c="dark" size={isTablet ? 'h2' : 'h1'} fw={600}>
            {lkTitle}
          </Title>
        </HeaderPortal>
      )}

      <AccreditationBanner className={s.root__banner} />
    </div>
  );
};

export default AccreditationPage;
